import React, { useState, useEffect, useRef } from 'react';
import { Wrapper, Button, DropdownMenu, DropdownItem } from './MenuButtonWrapper.styled';

const MenuButtonWrapper = ({ items = [] }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, right: 0 });
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleMenuClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      setDropdownPosition({
        top: rect.bottom + 4,
        right: windowWidth - rect.right,
      });
    }
    
    setShowDropdown(!showDropdown);
  };

  return (
    <Wrapper 
      ref={menuRef}
      data-menu-wrapper="true"
    >
      <Button
        ref={buttonRef}
        onClick={handleMenuClick}
        type="button"
      >
        ⋮
      </Button>
      {showDropdown && (
        <DropdownMenu
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          style={{
            top: `${dropdownPosition.top}px`,
            right: `${dropdownPosition.right}px`,
            zIndex: 999
          }}
        >
          {items.map((item, index) => (
            <DropdownItem
              key={index}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowDropdown(false);
                item.onClick?.();
              }}
            >
              {item.label}
            </DropdownItem>
          ))}
        </DropdownMenu>
      )}
    </Wrapper>
  );
};

export default MenuButtonWrapper; 